import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatUserPictureComponent } from './mat-user-picture.component';



@NgModule({
	declarations: [
		MatUserPictureComponent
	],
	imports: [
	  CommonModule
	],
	exports: [
		MatUserPictureComponent
	],
})
export class MatUserPictureModule { }
